import { render } from "./event-edit-card.vue?vue&type=template&id=2796bc3e"
import script from "./event-edit-card.vue?vue&type=script&lang=js"
export * from "./event-edit-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__